export default "__VITE_ASSET__DI$UavOK__";